/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { RecourseBookingDto } from '../../models/recourse-booking-dto';
import { RequestBuilder } from '../../request-builder';
import { StrictHttpResponse } from '../../strict-http-response';

export interface GetAllRecourseBookings$Params {}

export function getAllRecourseBookings(
  http: HttpClient,
  rootUrl: string,
  params?: GetAllRecourseBookings$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<Array<RecourseBookingDto>>> {
  const rb = new RequestBuilder(rootUrl, getAllRecourseBookings.PATH, 'get');
  if (params) {
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<RecourseBookingDto>>;
    }),
  );
}

getAllRecourseBookings.PATH = '/service/v1/recoursebooking';
